export default [
    // CANADIAN PROVINCES
    // --------------------------------------------------------------
    {
        code: 'qc',
        transKey: 'COMMONS_FORMS.CANADA_PROVINCES.QUEBEC',
        country: 'ca',
    },
    {
        code: 'on',
        transKey: 'COMMONS_FORMS.CANADA_PROVINCES.ONTARIO',
        country: 'ca',
    },
    {
        code: 'ns',
        transKey: 'COMMONS_FORMS.CANADA_PROVINCES.NOVA_SCOTIA',
        country: 'ca',
    },
    {
        code: 'nb',
        transKey: 'COMMONS_FORMS.CANADA_PROVINCES.NEW_BRUNSWICK',
        country: 'ca',
    },
    {
        code: 'mb',
        transKey: 'COMMONS_FORMS.CANADA_PROVINCES.MANITOBA',
        country: 'ca',
    },
    {
        code: 'bc',
        transKey: 'COMMONS_FORMS.CANADA_PROVINCES.BRITISH_COLUMBIA',
        country: 'ca',
    },
    {
        code: 'pe',
        transKey: 'COMMONS_FORMS.CANADA_PROVINCES.PRINCE_EDWARD_ISLAND',
        country: 'ca',
    },
    {
        code: 'sk',
        transKey: 'COMMONS_FORMS.CANADA_PROVINCES.SASKATCHEWAN',
        country: 'ca',
    },
    {
        code: 'ab',
        transKey: 'COMMONS_FORMS.CANADA_PROVINCES.ALBERTA',
        country: 'ca',
    },
    {
        code: 'nl',
        transKey: 'COMMONS_FORMS.CANADA_PROVINCES.NEWFOUNDLAND_AND_LABRADOR',
        country: 'ca',
    },
    {
        code: 'nt',
        transKey: 'COMMONS_FORMS.CANADA_PROVINCES.NORTHWEST_TERRITORIES',
        country: 'ca',
    },
    {
        code: 'yt',
        transKey: 'COMMONS_FORMS.CANADA_PROVINCES.YUKON',
        country: 'ca',
    },
    {
        code: 'nu',
        transKey: 'COMMONS_FORMS.CANADA_PROVINCES.NUNAVUT',
        country: 'ca',
    },
    // --------------------------------------------------------------
    // US States
    {
        code: 'al',
        transKey: 'COMMONS_FORMS.US_STATES.AL',
        country: 'us',
    },
    {
        code: 'ak',
        transKey: 'COMMONS_FORMS.US_STATES.AK',
        country: 'us',
    },
    {
        code: 'as',
        transKey: 'COMMONS_FORMS.US_STATES.AS',
        country: 'us',
    },
    {
        code: 'az',
        transKey: 'COMMONS_FORMS.US_STATES.AZ',
        country: 'us',
    },
    {
        code: 'ar',
        transKey: 'COMMONS_FORMS.US_STATES.AR',
        country: 'us',
    },
    {
        code: 'ca',
        transKey: 'COMMONS_FORMS.US_STATES.CA',
        country: 'us',
    },
    {
        code: 'co',
        transKey: 'COMMONS_FORMS.US_STATES.CO',
        country: 'us',
    },
    {
        code: 'ct',
        transKey: 'COMMONS_FORMS.US_STATES.CT',
        country: 'us',
    },
    {
        code: 'de',
        transKey: 'COMMONS_FORMS.US_STATES.DE',
        country: 'us',
    },
    {
        code: 'dc',
        transKey: 'COMMONS_FORMS.US_STATES.DC',
        country: 'us',
    },
    {
        code: 'fm',
        transKey: 'COMMONS_FORMS.US_STATES.FM',
        country: 'us',
    },
    {
        code: 'fl',
        transKey: 'COMMONS_FORMS.US_STATES.FL',
        country: 'us',
    },
    {
        code: 'ga',
        transKey: 'COMMONS_FORMS.US_STATES.GA',
        country: 'us',
    },
    {
        code: 'gu',
        transKey: 'COMMONS_FORMS.US_STATES.GU',
        country: 'us',
    },
    {
        code: 'hi',
        transKey: 'COMMONS_FORMS.US_STATES.HI',
        country: 'us',
    },
    {
        code: 'id',
        transKey: 'COMMONS_FORMS.US_STATES.ID',
        country: 'us',
    },
    {
        code: 'il',
        transKey: 'COMMONS_FORMS.US_STATES.IL',
        country: 'us',
    },
    {
        code: 'in',
        transKey: 'COMMONS_FORMS.US_STATES.IN',
        country: 'us',
    },
    {
        code: 'ia',
        transKey: 'COMMONS_FORMS.US_STATES.IA',
        country: 'us',
    },
    {
        code: 'ks',
        transKey: 'COMMONS_FORMS.US_STATES.KS',
        country: 'us',
    },
    {
        code: 'ky',
        transKey: 'COMMONS_FORMS.US_STATES.KY',
        country: 'us',
    },
    {
        code: 'la',
        transKey: 'COMMONS_FORMS.US_STATES.LA',
        country: 'us',
    },
    {
        code: 'me',
        transKey: 'COMMONS_FORMS.US_STATES.ME',
        country: 'us',
    },
    {
        code: 'mh',
        transKey: 'COMMONS_FORMS.US_STATES.MH',
        country: 'us',
    },
    {
        code: 'md',
        transKey: 'COMMONS_FORMS.US_STATES.MD',
        country: 'us',
    },
    {
        code: 'ma',
        transKey: 'COMMONS_FORMS.US_STATES.MA',
        country: 'us',
    },
    {
        code: 'mi',
        transKey: 'COMMONS_FORMS.US_STATES.MI',
        country: 'us',
    },
    {
        code: 'mn',
        transKey: 'COMMONS_FORMS.US_STATES.MN',
        country: 'us',
    },
    {
        code: 'ms',
        transKey: 'COMMONS_FORMS.US_STATES.MS',
        country: 'us',
    },
    {
        code: 'mo',
        transKey: 'COMMONS_FORMS.US_STATES.MO',
        country: 'us',
    },
    {
        code: 'mt',
        transKey: 'COMMONS_FORMS.US_STATES.MT',
        country: 'us',
    },
    {
        code: 'ne',
        transKey: 'COMMONS_FORMS.US_STATES.NE',
        country: 'us',
    },
    {
        code: 'nv',
        transKey: 'COMMONS_FORMS.US_STATES.NV',
        country: 'us',
    },
    {
        code: 'nh',
        transKey: 'COMMONS_FORMS.US_STATES.NH',
        country: 'us',
    },
    {
        code: 'nj',
        transKey: 'COMMONS_FORMS.US_STATES.NJ',
        country: 'us',
    },
    {
        code: 'nm',
        transKey: 'COMMONS_FORMS.US_STATES.NM',
        country: 'us',
    },
    {
        code: 'ny',
        transKey: 'COMMONS_FORMS.US_STATES.NY',
        country: 'us',
    },
    {
        code: 'nc',
        transKey: 'COMMONS_FORMS.US_STATES.NC',
        country: 'us',
    },
    {
        code: 'nd',
        transKey: 'COMMONS_FORMS.US_STATES.ND',
        country: 'us',
    },
    {
        code: 'mp',
        transKey: 'COMMONS_FORMS.US_STATES.MP',
        country: 'us',
    },
    {
        code: 'oh',
        transKey: 'COMMONS_FORMS.US_STATES.OH',
        country: 'us',
    },
    {
        code: 'ok',
        transKey: 'COMMONS_FORMS.US_STATES.OK',
        country: 'us',
    },
    {
        code: 'or',
        transKey: 'COMMONS_FORMS.US_STATES.OR',
        country: 'us',
    },
    {
        code: 'pw',
        transKey: 'COMMONS_FORMS.US_STATES.PW',
        country: 'us',
    },
    {
        code: 'pa',
        transKey: 'COMMONS_FORMS.US_STATES.PA',
        country: 'us',
    },
    {
        code: 'pr',
        transKey: 'COMMONS_FORMS.US_STATES.PR',
        country: 'us',
    },
    {
        code: 'ri',
        transKey: 'COMMONS_FORMS.US_STATES.RI',
        country: 'us',
    },
    {
        code: 'sc',
        transKey: 'COMMONS_FORMS.US_STATES.SC',
        country: 'us',
    },
    {
        code: 'sd',
        transKey: 'COMMONS_FORMS.US_STATES.SD',
        country: 'us',
    },
    {
        code: 'tn',
        transKey: 'COMMONS_FORMS.US_STATES.TN',
        country: 'us',
    },
    {
        code: 'tx',
        transKey: 'COMMONS_FORMS.US_STATES.TX',
        country: 'us',
    },
    {
        code: 'ut',
        transKey: 'COMMONS_FORMS.US_STATES.UT',
        country: 'us',
    },
    {
        code: 'vt',
        transKey: 'COMMONS_FORMS.US_STATES.VT',
        country: 'us',
    },
    {
        code: 'vi',
        transKey: 'COMMONS_FORMS.US_STATES.VI',
        country: 'us',
    },
    {
        code: 'va',
        transKey: 'COMMONS_FORMS.US_STATES.VA',
        country: 'us',
    },
    {
        code: 'wa',
        transKey: 'COMMONS_FORMS.US_STATES.WA',
        country: 'us',
    },
    {
        code: 'wv',
        transKey: 'COMMONS_FORMS.US_STATES.WV',
        country: 'us',
    },
    {
        code: 'wi',
        transKey: 'COMMONS_FORMS.US_STATES.WI',
        country: 'us',
    },
    {
        code: 'wy',
        transKey: 'COMMONS_FORMS.US_STATES.WY',
        country: 'us',
    },
    // --------------------------------------------------------------
];
